export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const stringToUrl = (x) => {
  return x.replace(/ /g, '-').toLowerCase()
}

const toTitleCase = (phrase) => {
  if (phrase.length === 3) {
    return phrase.toUpperCase()
  }
  return phrase
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const urlToString = (x) => {
  if (!x) {
    return ''
  }
  return toTitleCase(x.replace(/-/g, ' '))
}
